import LabRepository from "./LabRepository";

const resource = "/result-import";

export default {
  getAll(params) {
    return LabRepository.get(`${resource}?limit=all`, { params });
  },
  get(id, params) {
    return LabRepository.get(`${resource}/${id}`, { params });
  },
  create(payload) {
    return LabRepository.post(resource, payload, {
      'Content-Type': 'multipart/form-data'
    });
  },
  download(id) {
    return LabRepository.get(`${resource}/${id}/download`);
  },
  getFromExport(export_id) {
    return LabRepository.get(`${resource}/get-from-export/${export_id}`);
  }
};
